<template>
  <div class="product-bundle-gallery product__gallery-main-image">
    <div
      class="product-bundle-gallery__row flex"
      :class="{ 'product-bundle-gallery__row--duo': isDuo, 'product-bundle-gallery__row--trio': isTrio }"
    >
      <template v-for="collection in otherCollections">
        <BundleGalleryImageItem
          v-for="product in collection.selectedProducts"
          :key="product.variantId"
          :product="product"
          :product-type="collection.productType"
        />
      </template>
    </div>

    <div
      v-if="sachetsCollection"
      class="product-bundle-gallery__row product-bundle-gallery__row--sachets flex"
      :data-sachet-count="sachetsCollection.selectedProducts.length"
      :data-sachet-max-count="sachetsCollection.maximumQuantity"
    >
      <div class="inner flex justify-center">
        <BundleGalleryImageItem
          v-for="product in sachetsCollection.selectedProducts"
          :key="product.variantId"
          :product="product"
          :product-type="sachetsCollection.productType"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useBundleStore } from '../pinia/BundleStore'

import BundleGalleryImageItem from './bundle-gallery-image-item'

export default {
  components: {
    BundleGalleryImageItem
  },
  computed: {
    ...mapState (useBundleStore, [
      'bundle',
      'isDuo',
      'isTrio',
      'sachetsCollection',
      'otherCollections'
    ]),
  },
}
</script>
